<template>
  <div class="content-image">
    <uploader
      :src="obj.url"
      @uploaded="uploaded"
    />
    <!-- <img :src="obj.url"> -->
  </div>
</template>

<script>
import Uploader from '../Uploader'

export default {
  name: 'ContentImage',

  components: {
    Uploader
  },

  props: [
    'obj'
  ],

  methods: {
    uploaded(url) {
      this.obj.url = url
    }
  }
}
</script>

<style scoped>
</style>
